import { Reducer } from '@reduxjs/toolkit';

const paintMapPinsReducer: Reducer = (state) => ({
  ...state,
  paintMapPins: state.paintMapPins + 1,
});

export default paintMapPinsReducer;
